import { render, staticRenderFns } from "./PointCardList.vue?vue&type=template&id=14fefa0b&scoped=true"
import script from "./PointCardList.vue?vue&type=script&lang=js"
export * from "./PointCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fefa0b",
  null
  
)

export default component.exports